interface DataType {
   id: number;
   page: string;
   thumb: string;
   tag: string;
   date: string;
   title: string;
};

const blog_data: DataType[] = [
   {
      id: 1,
      page: "home_1",
      thumb: "/assets/img/blog/blog_post01.jpg",
      tag: "Marketing",
      date: "20 July, 2024",
      title: "How To Become idiculously Self-Aware In 20 Minutes",
   },
   {
      id: 2,
      page: "home_1",
      thumb: "/assets/img/blog/blog_post02.jpg",
      tag: "Students",
      date: "20 July, 2024",
      title: "Get Started With UI Design With Tips To Speed",
   },
   {
      id: 3,
      page: "home_1",
      thumb: "/assets/img/blog/blog_post03.jpg",
      tag: "Science",
      date: "20 July, 2024",
      title: "Make Your Own Expanding Contracting Content",
   },
   {
      id: 4,
      page: "home_1",
      thumb: "/assets/img/blog/blog_post04.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered",
   },

   // home_4

   {
      id: 1,
      page: "home_4",
      thumb: "/assets/img/blog/h4_blog_post01.jpg",
      tag: "Practice",
      date: "20 July, 2024",
      title: "Finding Zen: The Benefits of Yoga And Meditation For Mental Health",
   },
   {
      id: 2,
      page: "home_4",
      thumb: "/assets/img/blog/h4_blog_post02.jpg",
      tag: "Yoga",
      date: "20 July, 2024",
      title: "The Benefits of Yoga And Meditation For Mental Health",
   },
   {
      id: 3,
      page: "home_4",
      thumb: "/assets/img/blog/h4_blog_post03.jpg",
      tag: "Modern Instruments",
      date: "20 July, 2024",
      title: "The Benefits of Yoga And Meditation For Mental Health",
   },

   // home_5

   {
      id: 1,
      page: "home_5",
      thumb: "/assets/img/blog/h5_blog_post01.jpg",
      tag: "Marketing",
      date: "20 July, 2024",
      title: "Learn from Anywhere with Our eLearning Platform",
   },
   {
      id: 2,
      page: "home_5",
      thumb: "/assets/img/blog/h5_blog_post02.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "platform has given me the bility to learn on my own schedule",
   },
   {
      id: 3,
      page: "home_5",
      thumb: "/assets/img/blog/h5_blog_post03.jpg",
      tag: "Play Ground",
      date: "20 July, 2024",
      title: "learning platform where you can easily access course content",
   },

   // home_6

   {
      id: 1,
      page: "home_6",
      thumb: "/assets/img/blog/h6_blog_post01.jpg",
      tag: "Marketing",
      date: "20 July, 2024",
      title: "Learn from Anywhere with Our eLearning Platform",
   },
   {
      id: 2,
      page: "home_6",
      thumb: "/assets/img/blog/h6_blog_post02.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "platform has given me the bility to learn on my own schedule",
   },
   {
      id: 3,
      page: "home_6",
      thumb: "/assets/img/blog/h6_blog_post03.jpg",
      tag: "Play Ground",
      date: "20 July, 2024",
      title: "learning platform where you can easily access course content",
   },

   // home_8

   {
      id: 1,
      page: "home_8",
      thumb: "/assets/img/blog/h8_blog_post01.jpg",
      tag: "Cooking",
      date: "20 July, 2024",
      title: "Learn From Anywhere With Our ELearning Platform",
   },
   {
      id: 2,
      page: "home_8",
      thumb: "/assets/img/blog/h8_blog_post02.jpg",
      tag: "Food",
      date: "20 July, 2024",
      title: "Learn From Anywhere With Our ELearning Platform",
   },
   {
      id: 3,
      page: "home_8",
      thumb: "/assets/img/blog/h8_blog_post03.jpg",
      tag: "Recipes",
      date: "20 July, 2024",
      title: "Learn From Anywhere With Our ELearning Platform",
   },
];

export default blog_data;